import { types } from "mobx-state-tree";

export const NumberPair = types.custom<string, [number, number]>({
  name: "NumberPair",
  fromSnapshot(value: string): [number, number] {
    return value.split(",").map((i) => parseInt(i, 10)) as [number, number];
  },
  toSnapshot(value: [number, number]): string {
    return value.toString();
  },
  isTargetType(value: string | [number, number]): value is [number, number] {
    return value instanceof Array;
  },
  getValidationMessage(value: string): string {
    return `${value} does not look like a [number, number]`;
  }
});

export const StringPair = types.custom<string, [string, string]>({
  name: "StringPair",
  fromSnapshot(value: string): [string, string] {
    return value.split(",") as [string, string];
  },
  toSnapshot(value: [string, string]): string {
    return value.toString();
  },
  isTargetType(value: string | [string, string]): value is [string, string] {
    return value instanceof Array;
  },
  getValidationMessage(value: string): string {
    return `${value} does not look like a [string, string]`;
  }
});
